export default __webpack_public_path__ + "static/iconography-image-h-bea1c91aa14b2a83f9115c51c9bfd890d0009982dfeb72563405cb33be58505f.png";